import { useState } from 'react'
import AppDatePicker from '@/components/DatePickers/AppDatePicker'
import { isCrmOverdue } from '@/utils/crm'

type DueDateFieldProps = {
  /** ISO due date, or null when there is none. */
  value: string | null | undefined
  /** Server-computed overdue flag; derived from `value` when absent. */
  overdue?: boolean | null
  /** A picked day, or null when the user clears it. Fires once the user is done, not per digit. */
  onChange: (day: Date | null) => void
  disabled?: boolean
}

const sameDay = (a: Date | null, b: Date | null) =>
  a === b || (a !== null && b !== null && a.toDateString() === b.toDateString())

export default function DueDateField({
  value: dueAt,
  overdue,
  onChange,
  disabled = false,
}: DueDateFieldProps) {
  const saved = dueAt ? new Date(dueAt) : null
  const [draft, setDraft] = useState<Date | null>(saved)

  return (
    <AppDatePicker
      label="ת.יעד"
      value={draft}
      onChange={setDraft}
      onCommit={day => {
        if (!sameDay(day, saved)) onChange(day)
      }}
      danger={isCrmOverdue(dueAt, overdue)}
      disabled={disabled}
      clearable
      width="100%"
    />
  )
}
